<template>
  <Article>
    <Heading as="h1">
      <!--  -->
      Impact Litigation
    </Heading>
    <Heading as="h2">
      <!--  -->
      Our Expertise in Litigation
    </Heading>
    <p>
      While litigation is often a last resort in resolving disputes, the threats
      of litigation and assessment of litigation danger are an important aspect
      of the modern business environment. Hobson Bernardino + Davis has been
      known for the success of its litigators.
    </p>
    <p>
      Our firm has substantial involvement in virtually all types of litigation
      that affect businesses in the United States, from product liability to
      intellectual property, environmental and real estate litigation to
      professional liability disputes, to name but a few. The Firm’s litigation
      practice is distinguished by its proficiency at assembling versatile teams
      of trial lawyers to advance complex client interests. Each team is
      individually fashioned, taking into account the attorney’s knowledge of
      the area of law in dispute and litigation and trial experience. When it is
      in the best interests of the client, the team may include litigators from
      more than one of the firm’s offices. The firm’s attorneys have extensive
      trial experience before federal and state courts, arbitration panels and
      administrative agency tribunals throughout the United States.
    </p>
    <p>
      The attorneys of Hobson Bernardino + Davis have handled thousands of major
      business litigation matters, variously representing Fortune 500 companies,
      financial institutions, high-profile individuals, charities, religious
      organizations, governmental entities and venture capital firms. Our firm’s
      clients come from many industries and include companies headquartered in
      North and South America, Europe and Asia. Before litigation, our attorneys
      are frequently called upon to counsel clients on ways to minimize
      liability exposure, assess litigation risks and objectives and develop
      strategies in light of recent judicial trends. Although the firm’s
      practice includes highly experienced litigators, we often structure and
      negotiate creative, cost-effective, consensual resolutions that achieve
      our clients’ objectives without incurring the cost, delay and risk of
      protracted litigation. In cases that reach the courts, the firm offers
      clients the size and experience necessary to conduct full-scale
      litigation—quickly if needed—to protect their interests. Indeed, we
      believe that our reputation for litigation success enhances our ability to
      achieve favorable negotiated results. Our clients benefit from the
      credibility our attorneys have built up with the courts over many years.
    </p>
    <p>
      The trial lawyers of Hobson Bernardino + Davis have extensive experience
      in presenting complex matters to both juries and courts in high-stakes
      commercial cases. The group is known for its ability to prosecute or
      defend complex disputes in a cost-efficient and concise manner. Complex
      matters may arise because of the facts or legal issues surrounding a
      particular matter. The ability to explain such complexities to a jury in
      an easy-to-understand manner is a critical skill. Our firm’s trial
      attorneys handle class actions, complex technology matters and cases that
      require computer management of huge numbers of documents or facts. We
      possess a thorough knowledge of trial rules and procedures, including the
      application of recent technology to both discovery and courtroom
      presentation.
    </p>
    <p>
      Indeed, we believe that our reputation for success at trial enhances our
      ability to achieve favorable negotiated results. For example, the firm has
      had unbroken success against “specialist” firms because our attorneys have
      found that attacking a problem from multiple angles puts the specialist on
      unfamiliar ground where they are most vulnerable. For example,
      “specialist” attorneys are always confronted by our firm’s
      multi-disciplinary approach that invariably produces successful
      resolution. This is due to a usually superior knowledge of substantive
      law, the law of evidence, proven discovery techniques, law and motion
      tactics including summary judgment motions, and a hard-nosed, “ready to
      try the case before a jury” appearance that either leads to success before
      the jury, or, more often than not, is an ace in the hole at the
      negotiating table.
    </p>
    <Heading as="h2">
      <!--  -->
      Our Experience in Commercial Disputes
    </Heading>
    <p>
      Contract disputes form the basis of virtually all business litigation, and
      the attorneys of Hobson Bernardino + Davis have extensive experience in
      presenting complex contractual disputes to both juries and courts in
      high-stakes commercial cases. Among the clients that our firm’s attorneys
      have represented in complex contractual disputes are: Air France, Alcoa,
      Inc., Asbury Environmental Services, Atlantic Richfield Company, Inc., BP
      America, Inc., CalPERS, California Pacific Holdings, Inc., The Christian
      Broadcasting Network, Inc., the City of Cudahy, the City of Los Angeles
      Department of Water & Power, the City of South Gate, Du Pont de Nemours
      and Company, the FDIC, J-M Manufacturing Company, Inc., Koch Industries,
      Inc., Mercedes Benz of North America, MGM/UA Communications Company,
      Multicoat Products, Inc., Pacific Gas & Electric Co., Pacific Convenience
      & Fuels, LLC, The Walt Disney Company and World Oil, Inc. These clients
      and others can hire the largest law firms in the world to represent them,
      and our firm is extremely proud of the fact that its lawyers provide the
      degree of service that places them among the nation’s elite firms.
    </p>
    <Heading as="h2">
      <!--  -->
      Our Experience in Construction Law
    </Heading>
    <p>
      In construction-related litigation, Mr. Bernardino served as ARCO’s only
      outside counsel in the following types of matters: breach of contract,
      contract defaults, termination of contractors, defense and prosecution of
      property damage claims arising from construction projects, arbitration of
      payment disputes, prosecuting professional liability matters against
      design professionals arising out of catastrophic failures, litigation
      regarding payment for alleged or improper change orders/extra work and
      scope of work disputes, litigation arising out of claims of delay, many
      construction defect lawsuits (both prosecution and defense), disputes over
      insurance coverage, prosecution of bond/surety actions, and defense of
      mechanics lien claims.
    </p>
    <Heading as="h2">
      <!--  -->
      Our Experience in Representing Governmental Entities
    </Heading>
    <p>
      Hobson Bernardino + Davis has represented and currently represents a
      number of municipalities, such as the City of Cudahy and City of South
      Gate in a broad range of tort defense matters, including discrimination,
      fraud and civil rights violations, as well as complex financial and tax
      disputes. Our firm has also represented and currently represents public
      agencies, such as the Los Angeles Department of Water and Power, as well
      as private utilities such as Pacific Gas & Electric Company in a variety
      of real estate, construction, contract and bond disputes. Our firm also
      represents the Federal Deposit Insurance Corporation in a variety of
      litigation and transaction matters arising out of the recent financial and
      banking crisis.
    </p>
    <Heading as="h2">
      <!--  -->
      Our Broad Experience in Tort Matters
    </Heading>
    <p>
      In the course of representing the firm’s large industrial clients, such as
      ARCO, Koch Industries and World Oil, our attorneys have defended clients
      charged with a broad range of allegedly tortious conduct, from slip and
      falls at gasoline stations, to defense of major toxic torts resulting from
      pipeline ruptures and release of hazardous substances.
    </p>
    <Heading as="h2">
      <!--  -->
      Our Experience in Healthcare Law
    </Heading>
    <p>
      Stanley Friedman is recognized as a leading expert in the field of
      healthcare law. Among other things, Mr. Friedman was the lead attorney in
      Independent Living Center of Southern California v. Shewry, 543 F.3d 1047
      (9th Cir. 2008); Independent Living Center of Southern California v.
      Shewry, 543 F.3d 1050 (9th Cir.), cert. denied, 129 S. Ct. 2828 (2009);
      Managed Pharmacy Care v. Maxwell-Jolly, 603 F. Supp. 2d 1230 (C.D. Cal.
      2009); Independent Living Center of Southern California v. Maxwell-Jolly,
      572 F.3d 644 (9th Cir. 2009); In Re: Medi-Cal Reimbursement Rate Reduction
      Litigation, 652 F. Supp. 2d 1378 (J.P.M.L. 2009), and; Independent Living
      Center of Southern California v. Shewry, 590 F.3d 725 (2009). There are
      very few attorneys in the State of California with Mr. Friedman’s
      experience, qualification and unparalleled record of success litigating
      healthcare issues.
    </p>
    <Heading as="h2">
      <!--  -->
      Our Experience in Public Record Act Matters
    </Heading>
    <p>
      As a result of prior work experience with the United States Department of
      Justice and representing a variety of governmental entities as outside
      counsel, the firm’s attorneys have ample experience in both appropriate
      record keeping and preservation of documents. Moreover, the firm’s
      attorneys are experienced in utilizing the various public record and
      public information acts to both obtain and restrict access to confidential
      and proprietary information, as necessary.
    </p>
    <Heading as="h2">
      <!--  -->
      Our Experience in Banking and Finance Law
    </Heading>
    <p>
      Our firm’s recognized expertise in banking and finance law is reflected by
      the fact that Hobson Bernardino + Davis is one of the few law firms in the
      nation that has entered a Legal Service Agreement with the Federal Deposit
      Insurance Corporation. Accordingly, our firm is well positioned to
      represent its banking and credit union clients in virtually any type of
      litigation involving banking or finance law in any legal setting,
      including trial court, appearances before regulatory commissions and
      bankruptcy court. In addition to this practical experience, Mr. Bernardino
      also teaches Bankruptcy Law.
    </p>
    <Heading as="h2">
      <!--  -->
      Our Experience in Litigating Insurance Disputes
    </Heading>
    <p>
      Stanley Friedman recently won a 7.96 Million Dollar verdict for his client
      who was denied insurance coverage in bad faith. Mr. Friedman was also
      awarded attorneys fees. Our attorneys are trained to quickly analyze
      insurance claims and rapidly marshal all necessary documentation and facts
      to support any claims against any insurer. Our firm has never represented
      any insurance company; as such, the firm will never be in any conflict
      when representing its clients against any insurer or group of insurers.
    </p>
    <Heading as="h2">
      <!--  -->
      Our Experience in Environmental Litigation
    </Heading>
    <p>
      The attorneys of Hobson Bernardino + Davis have a wealth of experience in
      federal and state enforcement cases (both civil and criminal), permitting
      and other administrative proceedings. For example, the firm’s attorneys
      have acted as lead defense counsel in a considerable amount of nationwide
      product liability litigation concerning allegedly hazardous materials.
      Environmental litigation has long been a hallmark of the firm’s attorneys
      and a prominent aspect of the firm’s environmental practice. Examples of
      recent environmental cases litigated by our attorneys include: ARCO adv.
      Douglass, Santa Barbara County Superior Court, defense verdict following
      54 day jury trial on environmental torts; ARCO adv. Mitchell Land &
      Improvement Company, Riverside County Superior Court, nonsuit in favor of
      ARCO on disposal dispute; Koch Industries adv. Harms, Nueces County
      District Court, Texas, successful defense of environmental class action
      lawsuit resulting in de minimis settlement by Koch Industries; Koch
      Industries adv. OCI Superfund Site, United States District Court, W. D.
      Michigan, successful defense of “superfund” lawsuit resulting in de
      minimis settlement, and; In re OCI, United States District Court, Central
      District of California, successful defense of “superfund” lawsuit
      resulting in dismissal.
    </p>
    <p>
      Our firm’s interdisciplinary approach to the practice of law enhances its
      ability to represent our clients in litigation matters. Hobson Bernardino
      + Davis includes full-time trial lawyers, as well as lawyers from other
      practice areas such as tax, bankruptcy and real estate, who assist with
      particular issues on an as-needed basis. This interdisciplinary approach
      is particularly valuable to our clients because business disputes do not
      occur in a vacuum. Readily available, substantive expertise in related
      areas of the law is essential to efficient and effective representation.
    </p>
  </Article>
</template>

<script setup>
defineOptions({ name: "ViewDisclaimer" });
import Article from "../components/Article.vue";
import Heading from "../components/Heading.vue";
</script>
